import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse  } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { catchError, mergeMap, switchMap, tap } from 'rxjs/operators';
import { DynamicBackendConfigService } from './dynamic-backend-config.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private readonly JWT_TOKEN = 'jwt';
  private readonly REFRESH_TOKEN = 'refreshToken';

  private readonly uriPath = '/api/auth/create_token';
  private readonly refreshTokenUriPath = '/api/auth/refresh_token';
  
  uri = '';
  refreshTokenUri = '';

  constructor(private http: HttpClient, private dynamicBackend: DynamicBackendConfigService) {
    this.dynamicBackend.getApiUrl().subscribe(apiUrl => {
      this.uri = this.dynamicBackend.extractSecondURL(apiUrl ? `${apiUrl}${this.uriPath}` : this.uriPath);
      this.refreshTokenUri = this.dynamicBackend.extractSecondURL(apiUrl ? `${apiUrl}${this.refreshTokenUriPath}` : this.refreshTokenUriPath);
    });
  } 


  login(username: string, password: string): Observable<any> {
    return this.http.post(this.uri, { username, password })
        .pipe(
            tap((tokens: any) => this.storeTokens(tokens)),
            catchError(this.handleError)
        );
}

      private handleError(error: HttpErrorResponse): Observable<never> {
        if (error.status === 400) {
            // Custom handling for 401 errors
            return throwError(() => ({
                status: error.status,
                message: 'Unauthorized: Incorrect username or password.'
            }));
        } else {
            // Default handling for other errors
            return throwError(() => error);
        }
    }

    


  refreshToken() {
    const model = { "token" : localStorage.getItem(this.JWT_TOKEN), 
                    "refreshToken" : localStorage.getItem(this.REFRESH_TOKEN)};
    return this.http.post(`${this.refreshTokenUri}`, model)
                    .pipe(
                      tap((tokens:any) => this.storeTokens(tokens))                     
                    );
  }

  logout() {
    this.removeTokens();
  }

  getJwtToken() {
    return localStorage.getItem(this.JWT_TOKEN);
  }

  getRefreshToken() {
    return localStorage.getItem(this.REFRESH_TOKEN);
  }

  private storeTokens(tokens : any) {    
    console.log("New tokens stored");
    localStorage.setItem(this.JWT_TOKEN, tokens.token);
    localStorage.setItem(this.REFRESH_TOKEN, tokens.refreshToken);    
  }

  private removeTokens() {
    localStorage.removeItem(this.JWT_TOKEN);
    localStorage.removeItem(this.REFRESH_TOKEN);
  }

   /* login(username : string, password : string) : Observable<any> {
    //const model = { "username" : username, "password" : password};
    
      var t = this.dynamicBckend.getApiUrl();
      t = "http://"+t;
      console.log(t)

      return this.http.post(`${t}`, {username, password} )
      .pipe(
          tap((tokens : any) => this.storeTokens(tokens))
      );
  } */

  /* login(username: string, password: string): Observable<any> {
    return this.dynamicBackend.getApiUrl().pipe(
      switchMap(apiUrl => {
        console.log(apiUrl)
        const url = `${apiUrl}/login`; // Use the obtained apiUrl
        return this.http.post(url, { username, password }).pipe(
          tap((tokens: any) => this.storeTokens(tokens))
        );
      })
    );
  }
   */

  /* refreshToken() {
    const model = { "token" : localStorage.getItem(this.JWT_TOKEN), 
                    "refreshToken" : localStorage.getItem(this.REFRESH_TOKEN)};
    return this.http.post(`${this.refreshTokenUri}`, model)
                    .pipe(
                      tap((tokens : any) => this.storeTokens(tokens))                     
                    );
  } */

  /* refreshToken(): Observable<any> {
    const model = {
      token: localStorage.getItem(this.JWT_TOKEN),
      refreshToken: localStorage.getItem(this.REFRESH_TOKEN)
    };
    return this.dynamicBackend.getApiUrl().pipe(
      tap(apiUrl => {
        const url = `${apiUrl}${this.refreshTokenUri}`;
        return this.http.post(url, model).pipe(
          tap((tokens: any) => this.storeTokens(tokens))
        );
      })
    );
  }

  logout() {
    this.removeTokens();
  }

  getJwtToken() {
    return localStorage.getItem(this.JWT_TOKEN);
  }

  getRefreshToken() {
    return localStorage.getItem(this.REFRESH_TOKEN);
  }

  private storeTokens(tokens : any) {    
    console.log("New tokens stored");
    localStorage.setItem(this.JWT_TOKEN, tokens.token);
    localStorage.setItem(this.REFRESH_TOKEN, tokens.refreshToken);    
  }

  private removeTokens() {
    localStorage.removeItem(this.JWT_TOKEN);
    localStorage.removeItem(this.REFRESH_TOKEN);
  } */

}
